const science = [
    {
        "source": {
            "id": null,
            "name": "Hindustan Times"
        },
        "author": "Jahanvi Sharma",
        "title": "All about asteroid Bennu, a ticking n-bomb and NASA's mission to prevent it - Hindustan Times",
        "description": "Asteroid Bennu, termed one of the two most hazardous asteroids in our solar system, will be hitting the Earth and NASA is doing it all to prevent the collision. | World News",
        "url": "https://www.hindustantimes.com/world-news/all-about-asteroid-bennu-a-ticking-n-bomb-that-could-destroy-earth-and-nasas-mission-to-prevent-it-101695557272095.html",
        "urlToImage": "https://www.hindustantimes.com/ht-img/img/2023/09/24/1600x900/Space-Asteroid-Grab-0_1695520314670_1695562132428.jpg",
        "publishedAt": "2023-09-24T13:32:00Z",
        "content": "Asteroid Bennu, named after an ancient Egyptian mythological bird, that is associated with the Sun, creation and rebirth has been predicted to hit the Earth by NASA.\r\nThis undated image provided by N… [+2741 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "NASA says samples from asteroid Bennu will land on Earth Sunday - FOX 61",
        "description": "➡️Subscribe to FOX61 for exclusive content: https://www.youtube.com/Foxctlive➡️Visit our website: https://www.fox61.com/Follow FOX61 News on social media!➡️F...",
        "url": "https://www.youtube.com/watch?v=wuvtny6ND-4",
        "urlToImage": "https://i.ytimg.com/vi/wuvtny6ND-4/hqdefault.jpg",
        "publishedAt": "2023-09-24T13:03:42Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "SpaceX launches Starlink batch on record-tying 17th mission, nails landing - VideoFromSpace",
        "description": "A SpaceX Falcon 9 launched 22 Starlink satellites from Cape Canaveral Space Force Station in Florida on Sept. 23, 2023 at 11:38 p.m. EDT (0338 GMT on Sept. 2...",
        "url": "https://www.youtube.com/watch?v=E2LrYC0GaI0",
        "urlToImage": "https://i.ytimg.com/vi/E2LrYC0GaI0/maxresdefault.jpg",
        "publishedAt": "2023-09-24T11:00:13Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Live Science"
        },
        "author": "Briley Lewis",
        "title": "Mathematicians find 12000 new solutions to 'unsolvable' 3-body problem - Space.com",
        "description": "Calculating the way three things orbit each other is notoriously tricky — but a new study may reveal 12,000 new ways to make it work.",
        "url": "https://www.livescience.com/physics-mathematics/mathematicians-find-12000-new-solutions-to-unsolvable-3-body-problem",
        "urlToImage": "https://cdn.mos.cms.futurecdn.net/NuDfKpux9MUrZgFAHm97ZS-1200-80.jpg",
        "publishedAt": "2023-09-24T10:00:39Z",
        "content": "The three-body problem\r\n is a notoriously tricky puzzle in physics and mathematics, and an example of just how complex the natural world is. Two objects orbiting each other, like a lone planet around… [+3064 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Daijiworld.com"
        },
        "author": null,
        "title": "Study shows our gut microbes may determine bone health - Daijiworld.com",
        "description": "New York, Sep 24 (IANS): Our gut microbiome may have a role to play in our bone health and ward off the risk of osteoporosis and fractures, suggests a study.\r\nThe findings, published in Frontiers in Endocrinology, could one day provide the opportunity to alte…",
        "url": "https://www.daijiworld.com/news/newsDisplay?newsID=1123684",
        "urlToImage": "https://daijiworld.ap-south-1.linodeobjects.com/Linode/images3/rayan_240923_Gut1.jpg",
        "publishedAt": "2023-09-24T09:24:58Z",
        "content": "New York, Sep 24 (IANS): Our gut microbiome may have a role to play in our bone health and ward off the risk of osteoporosis and fractures, suggests a study.\r\nThe findings, published in Frontiers in … [+2196 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Artemis II: NASA prepares for a trip around the moon and beyond | 5 Things - USA TODAY",
        "description": "NASA’s 2024 return to the moon will be a milestone in space exploration.RELATED: https://www.youtube.com/watch?v=VmIn8hsxPwcThe Artemis II lunar mission will...",
        "url": "https://www.youtube.com/watch?v=MFCi3VAXMtc",
        "urlToImage": "https://i.ytimg.com/vi/MFCi3VAXMtc/maxresdefault.jpg",
        "publishedAt": "2023-09-24T09:00:17Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Transcontinentaltimes.com"
        },
        "author": "Russell Chattaraj",
        "title": "Tiny Jellyfish Show Astonishing Learning Abilities Despite Absence of Brain - Transcontinental Times",
        "description": "DENMARK: Researchers have uncovered an extraordinary cognitive ability in an unlikely source: brainless Caribbean box jellyfish. These delicate, centimeter-sized creatures have astounded scientists by demonstrating the capacity to learn from visual cues, a sk…",
        "url": "https://www.transcontinentaltimes.com/tiny-jellyfish-show-astonishing/",
        "urlToImage": "https://www.transcontinentaltimes.com/wp-content/uploads/2023/09/befunky_2023-8-0_13-38-3.jpg",
        "publishedAt": "2023-09-24T08:11:02Z",
        "content": "DENMARK: Researchers have uncovered an extraordinary cognitive ability in an unlikely source: brainless Caribbean box jellyfish. These delicate, centimeter-sized creatures have astounded scientists b… [+3134 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "WION"
        },
        "author": "Vikrant Singh",
        "title": "7 Unsolved Mysteries About Alien Life - WION",
        "description": "Do aliens exist or not, we still don't have the answer to this question. Maybe solving these mysteries might help our future generations.",
        "url": "https://www.wionews.com/web-stories/science/7-unsolved-mysteries-about-alien-life-1695540565668",
        "urlToImage": null,
        "publishedAt": "2023-09-24T07:41:34Z",
        "content": "In 1977, an unusual radio signal, known as the Wow! Signal, was detected from space. Its origin remains unknown, and efforts to replicate it have been unsuccessful."
    },
    {
        "source": {
            "id": null,
            "name": "ThePrint"
        },
        "author": "Akanksha Mishra",
        "title": "Interlocking logs from 476,000 years ago found in Zamibia 100,000 yrs older than oldest human fossil - ThePrint",
        "description": "ScientiFix, our weekly feature, offers you a summary of the top global science stories of the week, with links to their sources.",
        "url": "https://theprint.in/scientifix/interlocking-logs-from-476000-years-ago-found-in-zamibia-100000-yrs-older-than-oldest-human-fossil/1774778/",
        "urlToImage": "https://static.theprint.in/wp-content/uploads/2023/09/wood.png",
        "publishedAt": "2023-09-24T05:07:18Z",
        "content": "Submerged wood gets preserved because the limited oxygen supply slows decay, and over time sediment deposition on the wood also creates a fossilised structure.\r\nThe logs also show a kind of woodworki… [+6989 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Paleoartist brings back faces from the ancient past - Associated Press",
        "description": "(24 Sep 2023) John Gurche helps people understand what ancient humans looked like by creating lifelike models based on archaeological finds. The work require...",
        "url": "https://www.youtube.com/watch?v=3w3UT40C5jQ",
        "urlToImage": "https://i.ytimg.com/vi/3w3UT40C5jQ/maxresdefault.jpg",
        "publishedAt": "2023-09-24T05:04:34Z",
        "content": null
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "The Hindu",
        "title": "Genomic clues suggest humans’ ancestors nearly went extinct 9L years ago - The Hindu",
        "description": null,
        "url": "https://www.thehindu.com/sci-tech/science/genomic-sequencing-clues-human-ancestors-founder-effect/article67338304.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-24T05:00:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Film provides immersive look at Bay Area marine sanctuary using 3D camera technology - ABC7 News Bay Area",
        "description": null,
        "url": "https://www.youtube.com/watch?v=uol1ubLX65s",
        "urlToImage": null,
        "publishedAt": "2023-09-24T04:36:28Z",
        "content": "Your browser isnt supported anymore. Update it to get the best YouTube experience and our latest features. Learn more\r\nRemind me later"
    },
    {
        "source": {
            "id": null,
            "name": "Livemint"
        },
        "author": "Livemint",
        "title": "Chandrayaan-3: ISRO will wait another 14 days to get signals from - Mint",
        "description": "ISRO to continue attempts to revive Chandrayaan-3's lander and rover for another 14 days, uncertain of success.",
        "url": "https://www.livemint.com/science/news/chandrayaan3-isro-will-wait-another-14-days-to-get-signals-from-vikram-pragyan-s-somnath-says-dont-know-when-11695516719623.html",
        "urlToImage": "https://www.livemint.com/lm-img/img/2023/09/24/600x338/ANI-20230905266-0_1695387913873_1695518514986.jpg",
        "publishedAt": "2023-09-24T01:24:15Z",
        "content": "Indian Space Research Organization will wait another 14 days to establish contact with Chandrayaan-3's Vikram lander and Pragyan rover. ISRO will continue attempts to revive the Chandrayaan-3 lander … [+2014 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Giantfreakinrobot.com"
        },
        "author": "Kevin C. Neece",
        "title": "NASA Mission To Retrieve Samples From Mars Is Already Doomed - Giant Freakin Robot",
        "description": "The long-reaching goal of NASA to recover soil samples from the surface of Mars may never happen for one major reason.",
        "url": "https://www.giantfreakinrobot.com/sci/nasa-mission-samples-mars-doomed.html",
        "urlToImage": "https://www.giantfreakinrobot.com/wp-content/uploads/2022/09/mars-perseverance-rover.jpeg",
        "publishedAt": "2023-09-24T01:21:02Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Dinosaur for sale? Exceptionally well-preserved dinosaur skeleton to go on auction in Paris | ANC - ANC 24/7",
        "description": "On The Scene: Millions of years after dinosaurs disappeared from the face of the Earth, the skeleton of a Camptosaurus will go on auction in Paris on October...",
        "url": "https://www.youtube.com/watch?v=Y5-WWylqiP4",
        "urlToImage": "https://i.ytimg.com/vi/Y5-WWylqiP4/maxresdefault.jpg",
        "publishedAt": "2023-09-23T23:00:15Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "PBS"
        },
        "author": null,
        "title": "How India’s rover findings of sulfur in lunar soil could pave the way for future moon bases - PBS NewsHour",
        "description": "India's Chandrayaan-3 rover has found sulfur on the moon's surface at higher concentrations than previously seen. Sulfur in soils near the moon's poles might help astronauts live off the land one day.",
        "url": "https://www.pbs.org/newshour/science/how-indias-rover-findings-of-sulfur-in-lunar-soil-could-pave-the-way-for-future-moon-bases",
        "urlToImage": "https://d3i6fh83elv35t.cloudfront.net/static/2023/09/R_img2-1024x735.jpg",
        "publishedAt": "2023-09-23T22:50:36Z",
        "content": "In an exciting milestone for lunar scientists around the globe, Indias Chandrayaan-3 lander touched down 375 miles (600 km) from the south pole of the moon on Aug. 23, 2023.\r\nIn just under 14 Earth d… [+6222 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "ScienceAlert"
        },
        "author": "Felicity Nelson",
        "title": "Twists in Spacetime Might Explain Some of The Brightest Objects in The Universe - ScienceAlert",
        "description": "A 3D model of a black hole's erratic feeding pattern reveals a potential explanation for the bizarre behavior of quasars with a dimmer switch.",
        "url": "https://www.sciencealert.com/twists-in-spacetime-might-explain-some-of-the-brightest-objects-in-the-universe",
        "urlToImage": "https://www.sciencealert.com/images/2023/09/black-hole-accretion-disk-angle.gif",
        "publishedAt": "2023-09-23T21:01:19Z",
        "content": "A 3D model of a black hole's erratic feeding pattern reveals a potential explanation for the bizarre behavior of quasars with a dimmer switch.\r\nIt's highly unusual for galaxies to do anything in a hu… [+3470 chars]"
    },
    {
        "source": {
            "id": "the-hindu",
            "name": "The Hindu"
        },
        "author": "The Hindu",
        "title": "Young innovators of Cusat make a mark at international space-robotic event - The Hindu",
        "description": null,
        "url": "https://www.thehindu.com/news/cities/Kochi/young-innovators-of-cusat-make-a-mark-at-international-space-robotic-event/article67334396.ece",
        "urlToImage": null,
        "publishedAt": "2023-09-23T16:45:00Z",
        "content": null
    },
    {
        "source": {
            "id": "the-times-of-india",
            "name": "The Times of India"
        },
        "author": "TIMESOFINDIA.COM",
        "title": "What is Space Junk and why USA is concerned about its management - IndiaTimes",
        "description": "Trending News: The United States Federal Aviation Administration (FAA) has proposed a regulation to address the iss",
        "url": "https://timesofindia.indiatimes.com/etimes/trending/what-is-space-junk-and-why-usa-is-concerned-about-its-management/articleshow/103891072.cms",
        "urlToImage": "https://static.toiimg.com/thumb/msid-103891172,width-1070,height-580,imgsize-58318,resizemode-6,overlay-toi_sw,pt-32,y_pad-40/photo.jpg",
        "publishedAt": "2023-09-23T16:30:00Z",
        "content": "Parineeti Chopra and Raghav Chadha's wedding, set for September 24 in Udaipur, Rajasthan, is generating buzz. Remarkably, Parineeti appears to be an exceptionally composed bride, thanks to six months… [+390 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Weather Channel"
        },
        "author": "The Weather Channel",
        "title": "Bioengineered Silkworms Produce Spider Silk 6x Tougher than Bulletproof Kevlar! | Weather.com - The Weather Channel",
        "description": "Researchers modified the DNA of silkworms so that their silk-producing glands would instead create spider silk, a material excruciatingly hard to mass produce. - Articles from The Weather Channel | weather.com",
        "url": "https://weather.com/en-IN/india/science/news/2023-09-21-bioengineered-silkworm-produce-spider-silk-6x-tougher-kevlar",
        "urlToImage": "https://s.w-x.co/in-silkworms_usagerestrictionnone.jpg",
        "publishedAt": "2023-09-23T16:15:36Z",
        "content": "As fantastical as superheroes swinging amongst skyscrapers using mere spiderwebs might seem, there is nothing short of magic to this material. Despite being only a sixth the density, spider silk is f… [+2677 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Summer a million miles away! 1st and last day of season in EPIC space views - VideoFromSpace",
        "description": "In celebration of the northern hemisphere's summer of 2023, here are views from the DSCOVR satellite's EPIC instrument captured on June 21 and Sep. 22, 2023....",
        "url": "https://www.youtube.com/watch?v=tI4mkUB8kKA",
        "urlToImage": "https://i.ytimg.com/vi/tI4mkUB8kKA/hqdefault.jpg",
        "publishedAt": "2023-09-23T16:02:56Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Theindianpanorama.news"
        },
        "author": "@theindpanorama",
        "title": "NASA’s stunning new moon mosaic reveals lunar south pole in unprecedented detail - The Indian Panorama",
        "description": "Science & Technology | The mosaic was created with imagery acquired by Lunar Reconnaissance Orbiter Camera (LROC) and ShadowCam. Space agency NASA routinely captures stunning",
        "url": "https://www.theindianpanorama.news/science-technology/nasas-stunning-new-moon-mosaic-reveals-lunar-south-pole-in-unprecedented-detail/",
        "urlToImage": "https://www.theindianpanorama.news/wp-content/uploads/2023/09/NASA.jpg",
        "publishedAt": "2023-09-23T14:33:55Z",
        "content": "The mosaic was created with imagery acquired by Lunar Reconnaissance Orbiter Camera (LROC) and ShadowCam. Space agency NASA routinely captures stunning images of our universe, leaving space lovers me… [+2120 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Devdiscourse"
        },
        "author": "Devdiscourse News Desk",
        "title": "All you need to know about upcoming 'ring of fire' solar eclipse - Devdiscourse",
        "description": "Read more about All you need to know about upcoming 'ring of fire' solar eclipse on Devdiscourse",
        "url": "https://www.devdiscourse.com/article/science-environment/2605380-all-you-need-to-know-about-upcoming-ring-of-fire-solar-eclipse",
        "urlToImage": "https://www.devdiscourse.com/remote.axd?https://devdiscourse.blob.core.windows.net/devnews/23_09_2023_19_59_46_4459143.jpg?width=920&format=jpeg",
        "publishedAt": "2023-09-23T14:30:13Z",
        "content": "The \"ring of fire\" solar eclipse, an annular solar eclipse occurs when the Moon is near the part of its orbit that is most distant from Earth, will grace the skies over the U.S. on Saturday, October … [+1692 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "Tracking a Mission’s Historic Return to Earth on This Week @NASA – September 22, 2023 - NASA",
        "description": "Tracking a mission’s historic return to Earth, a year of science onboard the space station, and the safe arrival of the station’s newest resident astronaut …...",
        "url": "https://www.youtube.com/watch?v=-VIM6LSRLIA",
        "urlToImage": "https://i.ytimg.com/vi/-VIM6LSRLIA/maxresdefault.jpg",
        "publishedAt": "2023-09-23T14:00:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Interesting Engineering"
        },
        "author": "Amal Jos Chacko",
        "title": "Miracle or not? Magnetized sand flows uphill against gravity - Interesting Engineering",
        "description": "A recent paper published by researchers at Lehigh University discusses a perplexing phenomenon: sand flowing uphill. What's the magic behind it?",
        "url": "https://interestingengineering.com/science/miracle-or-not-magnetized-sand-flows-uphill-against-gravity",
        "urlToImage": "https://dnd2oi6izkvoi.cloudfront.net/2023/09/23/image/jpeg/6FWG1425f2sDtw6ySPRNGPgQZOtkfEzhLaqhWXD9.jpg",
        "publishedAt": "2023-09-23T13:05:00Z",
        "content": "However, on applying torque using magnets, each particle was observed to rotate, forming temporary doublets that exhibited cohesion and resulted in a negative angle of repose due to a negative coeffi… [+1463 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "DNA India"
        },
        "author": "Mahipal Chouhan",
        "title": "10 Mother animals that eat their own babies - DNA India",
        "description": "Here a list of 10 Mother animals that eat their own babies.",
        "url": "https://www.dnaindia.com/web-stories/viral/10-mother-animals-that-eat-their-own-babies-spider-lion-wild-wildlife-africa-1695470916247",
        "urlToImage": null,
        "publishedAt": "2023-09-23T12:52:00Z",
        "content": "Sep 23, 2023, 06:22PM IST"
    },
    {
        "source": {
            "id": null,
            "name": "Swarajya"
        },
        "author": "Karan Kamble",
        "title": "'Deorbit Vehicle' — NASA Calls On US Industry To Create International Space Station's Retirement Ride - Swarajya",
        "description": null,
        "url": "https://swarajyamag.com/science/deorbit-vehicle-nasa-calls-on-us-industry-to-create-international-space-stations-retirement-ride",
        "urlToImage": "https://swarajya.gumlet.io/swarajya/2022-02/26ba9b92-9225-4fac-bc20-47391bbbdf5a/1250px_The_station_pictured_from_the_SpaceX_Crew_Dragon_5__cropped_.jpg?w=1200&auto=format%2Ccompress&ogImage=true",
        "publishedAt": "2023-09-23T12:13:40Z",
        "content": "The National Aeronautics and Space Administration (NASA) is seeking proposals from the United States (US) industry for the development of the US Deorbit Vehicle (USDV).\r\nThe USDV will be the spacecra… [+3041 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "The Weather Channel"
        },
        "author": "The Weather Channel",
        "title": "James Webb Discovers Carbon Source on Jupiter's Moon 'Europa' | Weather.com - The Weather Channel",
        "description": "Astronomers have now used data from JWST to identify carbon dioxide on the icy surface of Europa, with the highest concentration found in a region called Tara Regio—a geologically young area known as \"chaos terrain.\"",
        "url": "https://weather.com/en-IN/india/space/news/2023-09-23-james-webb-discovers-carbon-source-on-jupiters-moon-europa",
        "urlToImage": "https://s.w-x.co/in-europa_1.jpg",
        "publishedAt": "2023-09-23T12:01:36Z",
        "content": "The next-generation powerful James Webb Space Telescope (JWST) has detected a carbon source on the surface of Jupiter's Moon, Europa.\r\nEuropa is among the few celestial bodies in our solar system tha… [+2339 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Live Science"
        },
        "author": "Jamie Carter",
        "title": "Space photo of the week: The sun's violent corona like it's never been seen before - Livescience.com",
        "description": "The sun's outer atmosphere was captured at previously impossible extreme ultraviolet wavelengths thanks to a last-minute engineering hack.",
        "url": "https://www.livescience.com/space/the-sun/space-photo-of-the-week-the-suns-violent-corona-like-its-never-been-seen-before",
        "urlToImage": "https://cdn.mos.cms.futurecdn.net/o6XExkN3ng3fnLMZzDRgpm-1200-80.jpeg",
        "publishedAt": "2023-09-23T11:00:00Z",
        "content": "What it is: The sun's outer atmosphere, as captured by the Extreme Ultraviolet Imager (EUI) on Solar Orbiter, a European Space Agency (ESA) spacecraft developed in collaboration with NASA.\r\nWhere it … [+2448 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "Medical Xpress"
        },
        "author": null,
        "title": "Best news stories 2023-09-23 - Medical Xpress",
        "description": "Daily top 2023-09-23",
        "url": "https://medicalxpress.com/visualstories/2023-09-23-daily-top.amp",
        "urlToImage": null,
        "publishedAt": "2023-09-23T10:32:59Z",
        "content": "Don't miss a beat! Here are yesterday's top stories"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "What Great Apes can tell us about language | The Royal Society - The Royal Society",
        "description": "Roma Agrawal meets human and animal psychologist Gilly Forrester to find out how hand dexterity in both humans and our Great Ape cousins can teach us about t...",
        "url": "https://www.youtube.com/watch?v=e1dAkkKplQA",
        "urlToImage": "https://i.ytimg.com/vi/e1dAkkKplQA/maxresdefault.jpg?sqp=-oaymwEmCIAKENAF8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGEogRyhlMA8=&rs=AOn4CLAy-anZa9fBbOTxhkvg1ePh1wZ9ew",
        "publishedAt": "2023-09-23T10:30:22Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "ZME Science"
        },
        "author": "Mihai Andrei",
        "title": "Electrons from Earth may be forming water on the moon - ZME Science",
        "description": "Our solar system is a pretty interesting place.",
        "url": "https://www.zmescience.com/space/electrons-earth-water-moon/",
        "urlToImage": "https://cdn.zmescience.com/wp-content/uploads/2023/09/magnetosphere.gif",
        "publishedAt": "2023-09-23T10:17:50Z",
        "content": "We know that there's ice on the moon. It's very surprising, but we know this. But how it got there is a different issue. Now, a new study suggests an unlikely source: electrons from our planet.\r\nA ma… [+3892 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "msnNOW"
        },
        "author": null,
        "title": "An amateur astronomer caught one of the brightest fireballs ever seen on Jupiter. Watch the rare video footage. - msnNOW",
        "description": null,
        "url": "https://www.msn.com/en-in/news/techandscience/an-amateur-astronomer-caught-one-of-the-brightest-fireballs-ever-seen-on-jupiter-watch-the-rare-video-footage/ar-AA1h97bu?ocid=weather-verthp-feeds",
        "urlToImage": null,
        "publishedAt": "2023-09-23T09:30:00Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Business Insider India"
        },
        "author": "Kelly Burch",
        "title": "NASA awarded $850,000 to a company that wants to pick up space trash the old-fashioned way — with bags - Business Insider India",
        "description": "NASA awarded TransAstra an $850,000 contract for its concept of Flytrap capture bags.Flytrap bags could be built large enough to scoop up space trash the size",
        "url": "https://www.businessinsider.in/science/news/nasa-awarded-850000-to-a-company-that-wants-to-pick-up-space-trash-the-old-fashioned-way-with-bags/articleshow/103888544.cms",
        "urlToImage": "https://www.businessinsider.in/photo/103888544/nasa-awarded-850000-to-a-company-that-wants-to-pick-up-space-trash-the-old-fashioned-way-with-bags.jpg?imgsize=114688",
        "publishedAt": "2023-09-23T09:12:00Z",
        "content": "In the middle of a space flight, an astronaut heard a massive bang. He looked up and saw a piece of space junk embedded in the window of the shuttle.\r\nIf the debris had been bigger, it could have blo… [+4160 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Education Diary"
        },
        "author": "India Education Diary Bureau Admin",
        "title": "NASA Releases First Season of Spanish-language Podcast - India Education Diary",
        "description": "In celebration of Hispanic Heritage Month, NASA is releasing new content for Universo curioso de la NASA, the agency’s first Spanish-language podcast. A five-episode season will start Tuesday, Sept. 19, with new episodes released weekly. In each",
        "url": "https://indiaeducationdiary.in/nasa-releases-first-season-of-spanish-language-podcast/",
        "urlToImage": "https://indiaeducationdiary.in/wp-content/uploads/2020/08/Default-Image-IED.png",
        "publishedAt": "2023-09-23T04:12:54Z",
        "content": "In celebration of Hispanic Heritage Month, NASA is releasing new content for Universo curioso de la NASA, the agencys first Spanish-language podcast. A five-episode season will start Tuesday, Sept. 1… [+3028 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "India Education Diary"
        },
        "author": "India Education Diary Bureau Admin",
        "title": "NASA Astronaut, Crewmates Reach Space Station for Science Expedition - India Education Diary",
        "description": "NASA astronaut Loral O’Hara and two cosmonauts safely arrived at the International Space Station Friday, Sept. 15, bringing its number of residents to 10 for the coming week.The Soyuz MS-24 spacecraft carrying O’Hara, as well as Oleg Kononenko and Ni",
        "url": "https://indiaeducationdiary.in/nasa-astronaut-crewmates-reach-space-station-for-science-expedition/",
        "urlToImage": "https://indiaeducationdiary.in/wp-content/uploads/2023/05/nasa_meatball_1_2.jpeg",
        "publishedAt": "2023-09-23T04:12:54Z",
        "content": "NASA astronaut Loral OHara and two cosmonauts safely arrived at the International Space Station Friday, Sept. 15, bringing its number of residents to 10 for the coming week.\r\nThe Soyuz MS-24 spacecra… [+1179 chars]"
    },
    {
        "source": {
            "id": null,
            "name": "YouTube"
        },
        "author": null,
        "title": "4 News Now's Rob King sits down with NASA Planetary Scientist - 4 News Now",
        "description": "►Subscribe: https://www.youtube.com/4NewsNow ►Website: http://www.kxly.com►Twitter: https://twitter.com/kxly4news►Facebook: https://www.facebook.com/KXLY4News",
        "url": "https://www.youtube.com/watch?v=FpDzW2VLkQ8",
        "urlToImage": "https://i.ytimg.com/vi/FpDzW2VLkQ8/maxresdefault.jpg",
        "publishedAt": "2023-09-23T02:00:39Z",
        "content": null
    },
    {
        "source": {
            "id": null,
            "name": "Zoom"
        },
        "author": "TN World Desk",
        "title": "Artemis Accords Partners Dream Up Space Policy Tool On Sidelines Of UNGA - Times Now",
        "description": "The project will be geared towards furthering cooperation between these nations in using space data for the greater good, said the US State Department.",
        "url": "https://www.timesnownews.com/world/artemis-accords-partners-dream-up-space-policy-tool-on-sidelines-of-unga-article-103878078",
        "urlToImage": "https://static.tnn.in/thumb/msid-103878078,updatedat-1695432750098,width-1280,height-720,resizemode-75/103878078.jpg",
        "publishedAt": "2023-09-23T01:32:30Z",
        "content": "Chandrayaan-3 Updates: ISRO Postpones Plan To Reactivate Pragyan Rover, Vikram Lander, To Be Revived On Sep 23"
    }
]

export default science;